import CollapsibleSection from "components/Section";
import { Button } from "components/Button";
import React, { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { TRole } from "types/dto";
import { Grid } from "components/Grid";
import { TRolesGridRow } from "../RolesChooserModal/RolesGrid/types";
import { Permission } from "components/Permission";

type TProps = {
  assignedRoles?: TRole[];
  onDeleteRoleGridActionClick: (role: TRolesGridRow) => void;
  isLoading: boolean;
  onAddRoleClick?: () => void;
};
export const RolesInfo = (props: TProps) => {
  const {
    assignedRoles,
    onDeleteRoleGridActionClick,
    isLoading,
    onAddRoleClick,
  } = props;

  const { t } = useTranslation();

  const gridRef = useRef(null);

  const renderAssignedRoles = useCallback(() => {
    if (assignedRoles) {
      return (
        <>
          <div className={"flex w-full justify-between items-center"}>
            <p className={"text-sm text-gray-90 font-bold mt-4"}>
              {t("assignedRoles")}:
            </p>
            <Permission allowed={["superadmin", "d_user"]}>
              <Button variant="outlined" onClick={onAddRoleClick}>
                {t("addRole")}
              </Button>
            </Permission>
          </div>
          <Grid
            ref={gridRef}
            gridKey={"id"}
            dataSource={assignedRoles}
            columns={[
              {
                dataField: "id",
                caption: t("id"),
              },
              {
                dataField: "name",
                caption: t("name"),
              },
              {
                caption: t("actions"),
                visible: true,
                width: 110,
                buttons: [
                  {
                    icon: "fa-solid fa-trash",
                    hint: t("delete"),
                    onClick: (e: any) => {
                      console.log("delete role clicked", e?.row.data);
                      onDeleteRoleGridActionClick(e?.row.data as TRolesGridRow);
                    },
                  },
                ],
              },
            ]}
            hasSearchPanel={false}
            hasPagination={false}
            hasGroupingFeatures={false}
            hasFilterBuilder={false}
          />
        </>
      );
    }
  }, [assignedRoles]);

  return (
    <>
      <CollapsibleSection
        title={t("rolesInfo")}
        collapsible={true}
        isLoading={isLoading}
        skeleton="table"
      >
        <div className={"flex flex-col w-full"}>
          {!(assignedRoles && assignedRoles?.length > 0) ? (
            <div className="w-full col-span-2 flex items-center justify-between">
              <span className="text-sm text-error-80">
                {t("noRoleAssignedYet")}
              </span>
              <Permission allowed={["superadmin", "d_user"]}>
                <Button variant="outlined" onClick={onAddRoleClick}>
                  {t("assignRoles")}
                </Button>
              </Permission>
            </div>
          ) : (
            <>{renderAssignedRoles()}</>
          )}
        </div>
      </CollapsibleSection>
    </>
  );
};
